import { render, staticRenderFns } from "./chooseForm2.vue?vue&type=template&id=19a003d8&"
import script from "./chooseForm2.vue?vue&type=script&lang=js&"
export * from "./chooseForm2.vue?vue&type=script&lang=js&"
import style0 from "./chooseForm2.vue?vue&type=style&index=0&id=19a003d8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports